module.exports = __webpack_public_path__ + "img/logo-genesis.a3f57daf.svg";